import React from 'react';
import { useDispatch } from 'react-redux';
import { setConfirmBoxStatus } from '../../redux/confirmBox';
import StatusLabel from 'modules/admin/wage/components/statusLabel';

const StatusCol = ({ value, data, tableManager }) => {
  const dispatch = useDispatch();

  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;

  const classNames = ('rgt-cell-inner rgt-text-truncate justify-content-between' + (additionalProps.className || '')).trim();
  const assignHandler = () => {
    if (value === '1') {
      dispatch(setConfirmBoxStatus(true));
    }
  };
  let statusConent = null;

  switch (value) {
    case 'in progress':
      statusConent = (
        <>
          <StatusLabel
            status="pending"
            labelText="Inprogress"
          />
        </>
      );
      break;

    case 'Sent':
      statusConent = (
        <>
          <StatusLabel
            status="pending"
            labelText="Sent"
          />
        </>
      );
      break;
    case 'Delivered':
      statusConent = (
        <>
          <StatusLabel
            status="approved"
            labelText="Delivered"
          />
        </>
      );
      break;
    case 'Suppressed':
      statusConent = (
        <>
          <StatusLabel
            status="disabled"
            labelText="Suppressed"
          />
        </>
      );
      break;
    case 'Bounced':
      statusConent = (
        <>
          <StatusLabel
            status="rejected"
            labelText="Bounced"
          />
        </>
      );
      break;
    case 'Quarantined':
      statusConent = (
        <>
          <StatusLabel
            status="quarantined"
            labelText="Quarantined"
          />
        </>
      );
      break;
    case 'FilteredSpam':
      statusConent = (
        <>
          <StatusLabel
            status="awaiting"
            labelText="FilteredSpam"
          />
        </>
      );
      break;
    case 'Expanded':
      statusConent = (
        <>
          <StatusLabel
            status="approved"
            labelText="Expanded"
          />
        </>
      );
      break;
    case 'Failed':
      statusConent = (
        <>
          <StatusLabel
            status="rejected"
            labelText="Failed"
          />
        </>
      );
      break;
    case 'failed':
      statusConent = (
        <>
          <StatusLabel
            status="rejected"
            labelText="Failed"
          />
        </>
      );
      break;
    case 'Viewed':
      statusConent = (
        <>
          <StatusLabel
            status="viewed"
            labelText="Viewed"
          />
        </>
      );
      break;
    case 'Clicked':
      statusConent = (
        <>
          <StatusLabel
            status="clicked"
            labelText="Clicked"
          />
        </>
      );
      break;

    case 'not started':
      statusConent = (
        <>
          <StatusLabel
            status="clicked"
            labelText="Not Started"
          />
        </>
      );
      break;

    case 'completed':
      statusConent = (
        <>
          <StatusLabel
            status="clicked"
            labelText="Completed"
          />
        </>
      );
      break;

    case 'present':
      statusConent = (
        <>
          <StatusLabel
            status="approved"
            labelText="Present"
          />
        </>
      );
      break;

    case 'absent':
      statusConent = (
        <>
          <StatusLabel
            status="rejected"
            labelText="Absent"
          />
        </>
      );
      break;
    // applicant registration status

    case 'In Progress':
      statusConent = (
        <>
          <StatusLabel
            status="pending"
            labelText="In Progress"
          />
        </>
      );
      break;
    case 'Completed':
      statusConent = (
        <>
          <StatusLabel
            status="clicked"
            labelText="Completed"
          />
        </>
      );
      break;
    case 'Vetting Pool':
      statusConent = (
        <>
          <StatusLabel
            status="approved"
            labelText="Vetting Pool"
          />
        </>
      );
      break;
    case 'User Created':
      statusConent = (
        <>
          <StatusLabel
            status="viewed"
            labelText="User Created"
          />
        </>
      );
      break;
    case 'Rejected':
      statusConent = (
        <>
          <StatusLabel
            status="rejected"
            labelText="Rejected"
          />
        </>
      );
      break;
    case 'Assigned Training Provider':
      statusConent = (
        <>
          <StatusLabel
            status="approved"
            labelText="Assigned Training Provider"
          />
        </>
      );
      break;
    // super admin email logs status
    case 'Opened':
      statusConent = (
        <>
          <StatusLabel
            status="approved"
            labelText="Opened"
          />
        </>
      );
      break;

    default:
      statusConent = value;
  }

  return (
    <div
      {...additionalProps}
      className={classNames}
      title={value}
      onClick={assignHandler}
    >
      {statusConent}
    </div>
  );
};

export default StatusCol;
